import { useSafetyDeviceSearchApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export const useDropdownOptions = () => {
  const { getSdDropdownInfos } = useSafetyDeviceSearchApi();

  const {
    data: searchResult,
    isFetching,
    isLoading,
  } = useCustomQuery("security-device-search", () => getSdDropdownInfos(), {
    staleTime: 1000 * 5 * 60,
  });

  return { searchResult, isFetching, isLoading };
};
